/*
This file was generated by the Surface compiler.
*/

export const imageHandler = {
  spinnerEl: null,
  mounted() {
    this.handleEvent(
      `thumbnail_generation_state:${this.el.id}`,
      maybeReloadImage(this.el),
    )

    let img = this.el.querySelector(":scope > img")

    if (img) {
      hide(img)
      img.addEventListener("load", (event) => {
        show(img)
      })
    }
  },
  updated() {
    let img = this.el.querySelector(":scope > img")

    // when component is updated that usually means
    // component received an event which will trigger
    // image reloading, so we show spinner again and let `onload` handler
    // do the rest
    if (img) {
      hide(img)
    }
  },
}

function maybeReloadImage(parentEl) {
  return ({ state }) => {
    let img = parentEl.querySelector(":scope > img")
    if (state == "available" && img) {
      img.src = img.src + "#" + new Date().getTime()
    }
  }
}

function hide(el) {
  el.classList.add("hidden")
}

function show(el) {
  el.classList.remove("hidden")
}
